import React from 'react';
import { Fade } from 'react-awesome-reveal';
import AIVisualization from '../components/AIVisualization';

const HomePage = () => {
    return (
        <div className="page-container home-page">
            <div className="home-layout">
                {/* Left Side - Content */}
                <div className="home-content">
                    <Fade triggerOnce duration={800}>
                        <section className="hero-section">
                            <h1 className="name-intro">
                                <span className="greeting">Hi, I'm </span>
                                <span className="name">Garvit Audichya</span>
                            </h1>
                        </section>
                    </Fade>

                    <Fade triggerOnce duration={800} delay={200}>
                        <section className="about-section">
                            <div className="about-content">
                                <p>
                                    I'm an AI focused Computer Science undergraduate specializing in <span className="highlight">machine learning, NLP, and generative AI</span>, with hands on experience building and deploying LLM powered systems for real world use.
                                </p>
                                <p>
                                    I build <span className="highlight">AI-driven automations and agentic workflows</span> that cut production overhead and scale content, research, and analysis with minimal manual effort using tools like <span className="highlight">n8n, LangChain, and custom agent pipelines</span>.
                                </p>
                                <p>
                                    I focus on building systems that are reliable, scalable, and deliver <span className="highlight">measurable impact</span> through strong engineering and real world problem solving.
                                </p>
                            </div>
                        </section>
                    </Fade>
                </div>

                {/* Right Side - Animation */}
                <Fade triggerOnce duration={1000} delay={400}>
                    <div className="home-visual">
                        <AIVisualization />
                    </div>
                </Fade>
            </div>
        </div>
    );
};

export default HomePage;
